module.exports = __webpack_public_path__ + "static/media/bg-football.1d35a938.png";